import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=6298fcab&scoped=true"
import script from "./PageTitleBar.vue?vue&type=script&lang=js"
export * from "./PageTitleBar.vue?vue&type=script&lang=js"
import style0 from "./PageTitleBar.vue?vue&type=style&index=0&id=6298fcab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298fcab",
  null
  
)

export default component.exports